import dayjs from 'dayjs';

import { VipTaskItemTypesEnum, VipTaskItemUserIdentifierTypesEnum } from '@shared/constants';

import { VipTaskItemFormValues } from './types';

export const VIP_TASK_ITEM_FORM_INITIAL_VALUES: VipTaskItemFormValues = {
  title: '',
  description: '',
  type: VipTaskItemTypesEnum.COMPLETE_TASKS,
  userIdentifierType: VipTaskItemUserIdentifierTypesEnum.EMAIL,
  completedTasksCount: 0,
  joinedTournamentsCount: 0,
  joinedTournamentsStartDate: dayjs(),
  reward: 0,
  order: 0,
  gameId: '',
  taskX: 0,
  betLimit: 0,
  lowerRangeX: 0,
  upperRangeX: 0,
  lowerLimitX: 0,
  totalTaskX: 0,
  countTaskX: 0,
};
